import React, { useState, useEffect } from 'react';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import logo from '../assets/images/logo.svg';
import passwordeye from '../assets/images/eye.svg';
import xlogo from '../assets/images/x_logo.png';
import glogo from '../assets/images/social_g.png';
import fblogo from '../assets/images/facebook.png';
import applelogo from '../assets/images/apple-black-logo.png';
import FeaturedPost from '../components/FeaturedPost';
import Footer from '../components/Footer';
import { Link, useNavigate } from 'react-router-dom';
import config from '../config/config';

const Register = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    role_type: 'user',
  });
  const [errorMessage, setErrorMessage] = useState(''); 
  const [showPassword, setShowPassword] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/Home');
    }
  }, [navigate]);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const oauthToken = queryParams.get('oauth_token');
    const oauthVerifier = queryParams.get('oauth_verifier');
    const roleType = 'user';

    const handleAuthResponse = async () => {
      try {
        const response = await fetch(`${config.baseURL}/auth/twitter`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            oauth_token: oauthToken,
            oauth_verifier: oauthVerifier,
            role_type: roleType,
          }),
        });

        const result = await response.json();
        if (result.success) {
          console.log('Twitter login successful:', result);
          localStorage.setItem('oauth_token', result.token);
          navigate('/Home');
        } else {
          console.error('Twitter login failed:', result.message);
        }
      } catch (error) {
        console.error('Error:', error);
      }
    };

    if (oauthToken && oauthVerifier) {
      handleAuthResponse();
    }
  }, [navigate]);

  const handleTwitterLogin = () => {
    const twitterAuthUrl = `${config.baseURL}/auth/twitter`;
    window.open(twitterAuthUrl, '_blank', 'noopener,noreferrer');
  };

  const handleFacebookLogin = () => {
    const clientId = '503205819153203'; 
    const redirectUri = `${config.baseURL}/auth/facebook/callback`; 
    const authorizationUrl = `https://www.facebook.com/v20.0/dialog/oauth?` +
      new URLSearchParams({
        client_id: clientId,
        redirect_uri: redirectUri,
        scope: 'email',
        response_type: 'code',
        state: 'some_random_string',
      }).toString();

    window.location.href = authorizationUrl;
  };

  const handleFacebookOAuthCallback = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');

    if (code) {
      try {
        const response = await fetch(`${config.baseURL}/auth/facebook/callback`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            code,
            role_type: 'user',
          }),
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.message || 'Facebook login failed');
        }

        if (result.success === false && result.error === true) {
          console.error(result.message);
        } else {
          console.log('Facebook login successful:', result);

          const loginUrl = `https://patreonpass.bvmwebsolutions.com/login?token=${encodeURIComponent(result.token)}&user_role=${encodeURIComponent(result.user_role)}`;
          window.location.href = loginUrl;
        }
      } catch (error) {
        console.error('Facebook login failed:', error);
      }
    }
  };

  useEffect(() => {
    handleFacebookOAuthCallback();
  }, []);
 
  const handleGoogleLogin = () => {
    const clientId = '1087363659375-a94omcoskevklauhjeh1of9pbfcpi14r.apps.googleusercontent.com';
    const redirectUrl = `${config.baseURL}/auth/google/callback`;
    const scopes = ['profile', 'email'];
    const authorizationUrl = `https://accounts.google.com/o/oauth2/v2/auth?` +
      new URLSearchParams({
        client_id: clientId,
        redirect_uri: redirectUrl,
        scope: scopes.join(' '),
        response_type: 'code',
        access_type: 'offline',
      }).toString();

    window.location.href = authorizationUrl;
  };

  const handleOAuthCallback = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');

    if (code) {
      try {
        const response = await fetch(`${config.baseURL}/auth/google/callback`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            code,
            role_type: 'user',
          }),
        });

        const result = await response.json(); 

        if (!response.ok) {
          throw new Error(result.message || 'Google login failed');
        }

        if (result.success === false && result.error === true) {
          console.error(result.message);
        } else {
          console.log('Google login successful:', result);

          const loginUrl = `https://patreonpass.bvmwebsolutions.com/login?token=${encodeURIComponent(result.token)}&user_role=${encodeURIComponent(result.user_role)}`;
          window.location.href = loginUrl;
        }
      } catch (error) {
        console.error('Google login failed:', error);
      }
    }
  };

  useEffect(() => {
    handleOAuthCallback();
  }, []);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [id]: value,
    }));
    setErrorMessage('');
  };

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const nameRegex = /^[A-Za-z\s]+$/;

    if (!nameRegex.test(formData.name)) {
      setErrorMessage('Name should contain only alphabets.');
      return;
    }

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!passwordRegex.test(formData.password)) {
      setErrorMessage('Password must contain at least 8 characters, including one uppercase, one lowercase, one number, and one special character.');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${config.baseURL}/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'Registration failed');
      }

      if (result.success === false && result.error === true) {
        setErrorMessage(result.message);
      } else {
        console.log('Registration successful:', result);
        setSuccessMessage('Account created successfully!');

        localStorage.setItem('token', result.token);
        setTimeout(() => {
          navigate('/Home');
        }, 2000);
      }
    } catch (error) {
      console.error('Registration failed:', error);
      setErrorMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleAppleLogin = () => {
    const clientId = 'com.yourapp.clientid'; 
    const redirectUri = `${config.baseURL}/auth/apple/callback`;
    const scopes = ['name', 'email'];
    const authorizationUrl = `https://appleid.apple.com/auth/authorize?` +
      new URLSearchParams({
        client_id: clientId,
        redirect_uri: redirectUri,
        scope: scopes.join(' '),
        response_type: 'code',
        response_mode: 'form_post',
      }).toString();
    window.location.href = authorizationUrl;
  };

  return (
    <div>
      <div className="login_wrap">
        <div className="login_wrap_container">
          <div className="right_login_box">
            <div className="img_content">
              <img src={logo} alt="logo" />
              <h4>Sign up to support your favorite creators</h4>
            </div>
          </div>
          <div className="left_login_box">
            <div className="login_box">
              <div id="form-container">
                <form id="signupForm" onSubmit={handleSubmit}>
                  <p className="p_sub_head">Create your account</p>                  
                  <div className="mb-4 position_relative">
                    <input 
                      type="text" 
                      className="form-control" 
                      id="name"                        
                      placeholder="Name" 
                      value={formData.name} 
                      onChange={handleChange} 
                    />
                    <label htmlFor="name" className="placeholder-label">Name</label>
                  </div>
                  <div className="mb-4 position_relative">
                    <input 
                      type="email" 
                      className="form-control" 
                      id="email"                        
                      placeholder="Email" 
                      value={formData.email} 
                      onChange={handleChange} 
                    />
                    <label htmlFor="email" className="placeholder-label">Email</label>
                  </div>
                  <div className="mb-4 pwd_side position_relative">
                    <input 
                      type={showPassword ? "text" : "password"} 
                      className="form-control" 
                      id="password" 
                      placeholder="Password" 
                      value={formData.password} 
                      onChange={handleChange} 
                    />
                    <label htmlFor="password" className="placeholder-label">Password</label>
                    <img 
                      className="password-toggle" 
                      src={passwordeye} 
                      alt="Show Password" 
                      onClick={togglePasswordVisibility}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                  <input type="hidden" id="role_type" value="user" />

                  {errorMessage && (
                    <div className="alert alert-danger" role="alert">
                      {errorMessage}
                    </div>
                  )}
                  {successMessage && (
                    <div className="alert alert-success" role="alert">
                      {successMessage}
                    </div>
                  )}

                  <div className="d-grid my-4 mb-0">
                    <button className="btn btn-primary" type="submit" disabled={loading}>
                      {loading ? (
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      ) : (
                        'Sign Up'
                      )}
                    </button>
                  </div>

                  <div className="small_text">
                    By signing up you agree to our <Link to="/terms">Terms of Service</Link> and <Link to="/privacy">Privacy Policy</Link>, and confirm that you are at least 18 years old.
                  </div>
                  <div className="row">
                    <div className="col text-end space_texts text-center account_already">
                      Already have an account? <Link to="/login" className="login">Log in</Link>
                    </div>
                  </div>
                </form>       
              </div>
            </div>
            <div className="social_logins"> 
              <Link to="/creator-register" className="button button--social-login button--create">Signup as a creator</Link>              
              <Link className="button button--social-login button--x" onClick={handleTwitterLogin}><img src={xlogo} alt="Sign in with X" /> Sign in with X</Link>
              <Link className="button button--social-login button--googleplus" onClick={handleGoogleLogin}><img src={glogo} alt="Sign in with Google" /> Sign in with Google</Link>
              <Link className="button button--social-login button--facebook" onClick={handleFacebookLogin}><img src={fblogo} alt="Sign in with Facebook" /> Sign in with Facebook</Link>
              <Link className="button button--social-login button--apple" onClick={handleAppleLogin}><img src={applelogo} alt="Sign in with Apple" /> Sign in with Apple</Link>
            </div>
          </div>
        </div>
      </div>
      <FeaturedPost />
      <Footer />
    </div>
  );

};

export default Register;
